var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 266.682,
    height: 195.111,
    viewBox: "0 0 266.682 195.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.976,
    y1: 0.5,
    x2: 0.06,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff81f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#9225fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#8318fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#7426fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#578ee1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(-1196.05 -2523.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(1196.05 2523.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M1396.334,0l-39.485,64.87L1325.825,96.46l29.332,32.434,40.9,65.717h59.229l-68.537-99L1454.718,0Z",
    transform: "translate(-1256.159 -0.001)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M1414.7,64.871,1378.036,0h-59.23l64.872,96.459-69.666,98.151h61.2l37.794-65.717,31.588-33.28Z",
    transform: "translate(-1314.011 -0.001)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M1407.935,2523.678h54.8",
    fill: "none",
    stroke: "#3840CD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M1407.935,2523.678h65.125",
    transform: "translate(-10.329 16)",
    fill: "none",
    stroke: "#3840CD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M1407.935,2523.678h85.083",
    transform: "translate(-30.287 48)",
    fill: "none",
    stroke: "#3840CD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M1407.935,2523.678h120.271",
    transform: "translate(-65.475 96)",
    fill: "none",
    stroke: "#3840CD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M1407.935,2523.678h75.279",
    transform: "translate(-20.483 32)",
    fill: "none",
    stroke: "#3840CD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M1407.935,2523.678h107.316",
    transform: "translate(-52.52 80)",
    fill: "none",
    stroke: "#3840CD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M1407.935,2523.678h96.637",
    transform: "translate(-41.841 64)",
    fill: "none",
    stroke: "#3840CD",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2fe16ddf3d4ed5eda0a6a3d7fd24e9a4.svg";
export { ForwardRef as ReactComponent };